import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Download, FileSpreadsheet } from 'lucide-react';
import { downloadAllLabels, exportDeliveries } from '../../../../../features/deliveries/deliveriesThunks';
import { selectIsKindRunning } from '../../../../../features/notifications/notificationsSlice';
import { NOTIFICATION_KIND } from '../../../../../features/notifications/notificationsConstants';
import { DropdownMenu } from '../../../../../components/ui/DropdownMenu';

/**
 * The options menu beside the title: what applies to the whole listing, the
 * labels of the page and the spreadsheet. What each item did is said by its
 * toast or by the Activity Center.
 *
 * The admin's other actions stay out because the backend refuses them to a
 * seller: the status-history export is `IsStaffAdminUser`.
 *
 * @param {object} props
 * @param {object} props.user
 * @param {object} props.filters - The deliveries slice's `filters`
 */
export const DeliveryActions = ({ user, filters }) => {
  const dispatch = useDispatch();
  const isDownloadingLabels = useSelector((state) => state.deliveries.isDownloadingLabels);

  // A queued job: the answer arrives over the socket minutes later, so what
  // disables the item is the notification still being open.
  const isExportingDeliveries = useSelector(
    selectIsKindRunning(NOTIFICATION_KIND.DOWNLOAD_DELIVERIES)
  );

  const globalActions = [
    {
      // "de esta página": the endpoint always pages, so it never was "todas".
      label: 'Descargar etiquetas de esta página',
      icon: Download,
      onClick: () => dispatch(downloadAllLabels({ filters, user })),
      disabled: isDownloadingLabels,
      description: isDownloadingLabels
        ? 'Armando el PDF con las etiquetas'
        : 'Las de los envíos que ves en la tabla, en un PDF',
    },
    {
      label: 'Exportar a Excel',
      icon: FileSpreadsheet,
      onClick: () => dispatch(exportDeliveries()),
      disabled: isExportingDeliveries,
      dividerBefore: true,
      description: isExportingDeliveries
        ? 'Ya hay un reporte en curso, te avisamos al terminar'
        : 'Se genera en segundo plano y llega al Centro de Actividad'
    }
  ];

  return (
    <div data-testid="delivery-actions" className="flex items-center justify-end">
      <DropdownMenu
        triggerLabel="Opciones"
        items={globalActions}
      />
    </div>
  );
};
